<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.5074 9.71727C14.5074 11.2955 13.2217 12.5758 11.6358 12.5758C10.0496 12.5758 8.76409 11.2955 8.76409 9.71727C8.76409 8.13863 10.0498 6.85869 11.6358 6.85869C13.2221 6.85858 14.5074 8.13852 14.5074 9.71727ZM17.4869 9.71727C17.4869 6.55965 14.9156 4 11.7435 4C8.5715 4 6 6.55965 6 9.71727C6 11.1056 6.49762 12.3785 7.32453 13.3687L11.7484 19.7224L16.237 13.276C16.3982 13.0752 16.5459 12.8635 16.6791 12.641L16.7245 12.5762H16.717C17.2058 11.7347 17.4869 10.7591 17.4869 9.71727Z"
      fill="black"
    />
  </svg>
</template>
